/*
 payment/payment/view

 create and handle all dom-nodes for the payments
 all dom-updates are routed from this module.
 */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import viewPaymentform from './view-paymentform.js';
import viewSpinner from '../../commonview/lib/view-spinner.js';
import viewWrap from '../../commonview/lib/view-wrap.js';
import viewPaymentmessage from './view-paymentmessage.js';
import viewConfirmationmessage from '../../commonview/lib/view-confirmationmessage.js';
import viewBinaryquestion from '../../commonview/lib/view-binaryquestion.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create;
/* elements are set from the selectorsobject, which is set in the global navigation, router.js*/
const selectors = {
	textkeys: 'not set',
	wrap: null
};
let ageverifycb;
let agedontverifycb;
let elements = {};
let viewSpinnerInstance;
let textkeysObj;
let complianceverifycb;
let compliancedontverifycb;

function ageBinaryQuestionConfirmCb() {
	viewBinaryquestion.close();
	actions.view({
		ageverification: {
			confirm: true
		}
	});
	ageverifycb(); // this is for example only used by the navigation to reroute
}

function ageBinaryQuestionRejectCb() {
	viewBinaryquestion.close();
	actions.view({
		ageverification: {
			confirm: false
		}
	});
	agedontverifycb(); // this is for example only used by the navigation to reroute
}

function complianceBinaryQuestionConfirmCb() {
	viewBinaryquestion.close();
	actions.viewPaymentform({
		ukcompliance: {
			confirm: true
		}
	});
	complianceverifycb(); // this is for example only used by the navigation to reroute
}

function complianceBinaryQuestionRejectCb() {
	viewBinaryquestion.close();
	actions.viewPaymentform({
		ukcompliance: {
			confirm: false
		}
	});
	compliancedontverifycb(); // this is for example only used by the navigation to reroute
}

function deleteAllElements() {
	if (elements) {
		elements.assembled = false;
	}
	core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'payment/view:32');
}

function createWrapPaymentform() {
	return create({
		type: 'div',
		class: 'js-wrap-paymentform u-height-100'
	});
}

function createWrapContent() {
	return create({
		type: 'main',
		class: 'payment__content-wrapper grid-u-sm-1 u-relative'
	});
}

function assembleElements() {
	if (!elements.assembled) {
		elements.wrapContent = (elements.wrapContent || createWrapContent());
		elements.wrapPaymentform = (elements.wrapPaymentform || createWrapPaymentform());
		elements.wrapContent.appendChild(elements.wrapPaymentform);
		elements.wrap.appendChild(elements.wrapContent);
		elements.assembled = true;
	}
}

function cleanupView() {
	deleteAllElements();
	viewConfirmationmessage.close();
	if (viewSpinnerInstance) {
		viewSpinnerInstance.close();
	}
	viewPaymentform.close();
	viewPaymentmessage.close();
	viewWrap.hide((elements && elements.wrap));
}
export default {
	init(conf) {
		selectors.wrap = (conf.wrap || selectors.wrap);
		ageverifycb = (conf.ageverifycb || function empty() {});
		agedontverifycb = (conf.agedontverifycb || function empty() {});
		complianceverifycb = (conf.complianceverifycb || function empty() {});
		compliancedontverifycb = (conf.compliancedontverifycb || function empty() {});

		elements = core.selectElements(selectors, 'payment:view:55');
		textkeysObj = viewTextkeys.depositflow();
		viewSpinnerInstance = viewSpinner.create({
			wrap: elements.wrap
		});
		assembleElements();
		viewWrap.show((elements && elements.wrap));
		/* inject area for messages */
		viewPaymentmessage.init({
			wrapElm: elements.wrap,
			wrap: elements.wrap
		});
		/* inject area for payments: methods and selected form */
		viewPaymentform.init({
			wrap: elements.wrapPaymentform
		});
	},
	update(state) {
		/* Data modules send their state with the modulename as property. i.e 'state.foomodule. A 'view_foobar' uses 'state.foomodule'. */
		let failTitle;
		let failText;
		let failBtn;
		let confirmCb;
		let acceptButtonTxt;
		let denyButtonTxt;
		if (state) {
			if (state.fetch_paymentmethods) {
				if (state.fetch_paymentmethods.error) {
					failTitle = 'something went wrong..';
					failText = 'during initialization of payments';
					failBtn = 'ok';
					confirmCb = cleanupView;
					viewConfirmationmessage.show('default-failure', failTitle, failText, failBtn, confirmCb);
				}
			}
			if (state.paymentmethods) {
				if (state.paymentmethods.error) {
					failTitle = 'something went wrong...';
					failText = 'during fetch of methods';
					failBtn = 'ok';
					viewConfirmationmessage.show('default-failure', failTitle, failText, failBtn, confirmCb);
				} else {
					viewPaymentform.update(state);
				}
			}
			if (state.fetch_amounts) {
				viewPaymentform.update(state);
			}
			if (state.fetch_methoddetails) {
				viewPaymentform.update(state);
			}
			if (state.fetch_currencies) {
				viewPaymentform.update(state);
			}
			if (state.fetch_fees_and_limits) {
				viewPaymentform.update(state);
			}
			if (state.fee) {
				viewPaymentform.update(state);
			}
			if (state.submit_payment) {
				if (state.submit_payment.pending) {
					viewSpinnerInstance.show();
				} else if (state.submit_payment.success) {
					viewSpinnerInstance.hide();
				} else {
					viewSpinnerInstance.hide();
				}
				if (state.submit_payment.error && !state.submit_payment.ageverifyerror) {
					failTitle = state.submit_payment.title;
					failText = state.submit_payment.message;
					failBtn = 'ok';
					viewConfirmationmessage.show('default-failure', failTitle, failText, failBtn);
				} else if (state.submit_payment.ageverifyerror) {
					failTitle = state.submit_payment.title || '';
					failText = state.submit_payment.message || '';
					acceptButtonTxt = textkeysObj['verify-age-accept-text'];
					// acceptButtonTxt = state.submit_payment.buttontext || 'verify-age-accept-text';
					denyButtonTxt = textkeysObj['verify-age-deny-text'];
					viewBinaryquestion.show(failText, acceptButtonTxt, denyButtonTxt, ageBinaryQuestionConfirmCb, ageBinaryQuestionRejectCb, failTitle);
				} else if (state.submit_payment.complianceerror) {
					acceptButtonTxt = textkeysObj['uk-verify-accept-text'];
					denyButtonTxt = textkeysObj['uk-verify-deny-text'];
					failText = state.submit_payment.message || '';
					failTitle = state.submit_payment.title || '';
					viewBinaryquestion.show(failText, acceptButtonTxt, denyButtonTxt, complianceBinaryQuestionConfirmCb, complianceBinaryQuestionRejectCb, failTitle);
				}
				if (state.submit_payment) {
					viewPaymentform.update(state);
				}
			}
			if (state.get_payment_result) {
				viewPaymentmessage.update(state);
				viewPaymentform.update(state);
			}
			if (state.first_time_uk_deposit) {
				/* this info is used by viewPaymentform and may be recieved
				after or before the viewPaymentform is created */
				viewPaymentform.update(state);
			}
			if (state.external_panel_and_window_handler) {
				if (state.external_panel_and_window_handler.pending) {
					// viewSpinnerInstance.show();
				} else {
					// viewSpinnerInstance.hide();
				}
			}
		} else {
			console.warn('payment/view:27:update:can not update, no state object provided.', state);
		}
	},
	close() {
		cleanupView();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view.js